var public_nurseslounge_degree_information = {
    init:function($params){
        var $degree = JSON.parse(libs.unlock($params));
        public_nurseslounge_degree_information.information_events($degree);
        try{
            google.maps.event.addListener(window, "load", public_nurseslounge_degree_information.information_location_map($degree));
        }catch (e) {

        }
        public_nurseslounge_degree_information.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
    },
    information_events:function($degree){
        $(".nav-underline a:eq(0)").addClass('active');
        var $degreeInformation = $("#nurseslounge-degree-information");
        var $degreeInformationRight = $degreeInformation.find('.nurseslounge-degree-information-right');
        var $degreeInformationLeft = $degreeInformation.find('.nurseslounge-degree-information-left');
        var $activityInfo = $degreeInformationRight.find('a[data-action="why-study-here"]');
        var $requestInfo = $degreeInformationRight.find('a[data-action="request-info"]');
        var $addReview = $degreeInformationRight.find('.add-review');
        var $discoverMoreDegrees = $degreeInformationRight.find('.discover-more-degrees');
        var $discoverMoreJobs = $degreeInformationRight.find('.discover-more-jobs');
        var $detail = $degreeInformationLeft.find('.detail');
        var $readMore = $degreeInformationLeft.find('.read-more');
        var $nav = $(".nav-underline");
        var $key = $nav.data('key');
        var $degreeKey = $nav.data('degree_key');
        var $params = {key:$key, degree_key:$degreeKey};
        $activityInfo.unbind().click(function(){
            window.open($degree.lounge.public_link, '_blank');
        });
        $requestInfo.unbind().click(function(){
            $params = $.extend({}, $params, {id:'degreeRequestInfo'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $addReview.unbind().click(function(){
            $params = $.extend({}, $params, {id:'degreeReviews'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $discoverMoreDegrees.unbind().click(function(){
            $params = $.extend({}, $params, {id:'degreeInformation'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $discoverMoreJobs.unbind().click(function(){
            $params = $.extend({}, $params, {id:'nursingJobs'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $detail.unbind().click(function(){
            $params = $.extend({}, $params, {id:'degreeRequestInfo'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $readMore.unbind().click(function(){
            $params = $.extend({}, $params, {id:'degreeReadMore'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $(".nav-underline a").unbind().click(function(){
            var $that = $(this);
            var $id = $that.data('id');
            $params = $.extend({}, $params, {id:'degree'+ libs.ucfirst($id)});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
    },
    information_location_map:function($degree){
        var $location = $degree.lounge.location ? $degree.lounge.location : null;
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
            var $iconUrl =  './../../../../bimg/NursesLounge/active.png';
            var $map = new google.maps.Map(document.getElementById('nurseslounge-degree-information-right-map'), {
                center:$position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: 15
            });
            $map.setTilt(0);
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
        }
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-degree-information .nurseslounge-degree-information-right .banners")
        });
    },
};
